import React from 'react'
import styled from '@emotion/styled'
import { Select } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../../../../logic/context'

const OrdersetCategoryHeaderLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
  align-content: center;
`

interface OrdersetCategoryHeaderProps {
  handleSelectedCategoryIdChange: (updatedCategoryId: string) => void
}

export const OrdersetCategoryHeader = (props: OrdersetCategoryHeaderProps) => {
  const { handleSelectedCategoryIdChange } = props
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const packageCategories = pageLogic?.packageCategories ?? []

  return (
    <OrdersetCategoryHeaderLayout>
      <span>Category</span>
      <Select
        label=""
        description=""
        placeholder="Select Category"
        data={packageCategories}
        searchable={true}
        defaultValue={packageCategories[0].value}
        onChange={(value) => handleSelectedCategoryIdChange(value ?? '')}
        dropdownComponent="div"
      />
    </OrdersetCategoryHeaderLayout>
  )
}
